import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { translate } from './i18n';

const STORAGE_KEY = 'rb_language';

const readStoredLanguage = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'en' || v === 'id' ? v : 'en';
  } catch {
    return 'en';
  }
};

const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: (path) => path,
});

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(readStoredLanguage);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = useCallback((lang) => {
    setLanguageState(lang);
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
  }, []);

  const t = useCallback((path, vars) => translate(language, path, vars), [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
export const useT = () => useContext(LanguageContext).t;
